module.exports = __webpack_public_path__ + "media/assets/svgs/check-green-fat-13acebb9173ac6568d7bd08384a49ac2.svg";